export default __webpack_public_path__ + "static/media/be_the_one.73768c4b.png";